import type { AppDispatch } from '/business/shared/state/store';
import type { BasketTableAnswerItem } from '/index';

const setEditingItemId =
  (itemId: BasketTableAnswerItem['itemId'] = null, itemKey = '') =>
  async (dispatch: AppDispatch) => {
    await dispatch({ type: 'EDITING_ITEM_ID_SET', itemId, itemKey });
  };

export default setEditingItemId;
